import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { CheckBox, DateBox, SelectBox, TextArea } from 'devextreme-react';
import { SubstitutionVehicleTemplateTypes } from "../../../../../Constantes/documentataionRequestTypes";
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors";
import dayjs from "dayjs";
import { selectFactoryProvinces, selectFactoryProvincesWithOffices } from "../../../../../redux/factoryProvinces/selectors";
import { getFactoryProvinces, getFactoryProvincesWithOffices } from "../../../../../redux/factoryProvinces/thunks";
import { getFactoryCities } from "../../../../../redux/factoryCities/thunks";
import { selectFactoryCities } from "../../../../../redux/factoryCities/selectors";
import {selectFactoryOfficesByCity, selectFactoryOfficesByProvince } from "../../../../../redux/factoryOffices/selectors"
import {getFactoryOfficesByCityId, getFactoryOfficesByProvinceId } from "../../../../../redux/factoryOffices/thunks"
import { getFactoryRentTypes } from "../../../../../redux/factoryRentTypes/thunks";
import { selectFactoryRentTypes } from "../../../../../redux/factoryRentTypes/selectors";
import { getFactoryChannels } from "../../../../../redux/factoryChannels/thunks";
import { selectFactoryChannels } from "../../../../../redux/factoryChannels/selectors";
import { getFactoryCategories } from "../../../../../redux/factoryCategories/thunks";
import { selectFactoryCategories } from "../../../../../redux/factoryCategories/selectors";
import { selectFactoryTypes } from "../../../../../redux/factoryTypes/selectors";
import { selectFactoryRates } from "../../../../../redux/factoryRates/selectors";
import { getFactoryRates } from "../../../../../redux/factoryRates/thunks";
import { getFactoryTypes } from "../../../../../redux/factoryTypes/thunks";
import { getFactoryBranches } from "../../../../../redux/factoryBranches/thunks";
import { selectContract } from "../../../../../redux/contract/selectors";
import { selectFactoryBranches } from "../../../../../redux/factoryBranches/selectors";
import { factoryActive } from "../../../../../Constantes/factoryActive";
import { getFactoryCategoriesSVUnlimited } from "../../../../../redux/factoryCategoriesSVUnlimited/thunks";
import { openModal } from "../../../../../redux/modal/modalSlice";
import { getFactoryModalityBag, getFactoryModalityPool, getFactoryModalityTypeDaysYear } from "../../../../../redux/factoryBagGroups/thunks";
import { selectFactoryBagGroups } from "../../../../../redux/factoryBagGroups/selectors";

function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function SubstitutionVehicleRequestForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const typesLoading = useSelector(selectTaxonomyTemplatesLoading)
const [type, setType] = useState(dataForm?.templateCode)
const {plate} = useSelector(selectContract);
const {customerCode} = useSelector(selectContract);
const [officeSchedules, setOfficeSchedules] = useState({});
const provincesWithOffices = useSelector(selectFactoryProvincesWithOffices);
const allProvinces = useSelector(selectFactoryProvinces);
const cities = useSelector(selectFactoryOfficesByProvince);
const allCities = useSelector(selectFactoryCities);
const officesByCity = useSelector(selectFactoryOfficesByCity);
const rentTypes = useSelector(selectFactoryRentTypes)
const channels = useSelector(selectFactoryChannels)
const categories = useSelector(selectFactoryCategories)
const typesInfo = useSelector(selectFactoryTypes)
const rates = useSelector(selectFactoryRates)
const branches = useSelector(selectFactoryBranches)
const groups = useSelector(selectFactoryBagGroups)
const mtrSubtypes = [{name: "No MTR", value: false}, {name: "MTR", value: true}];
const vanRequestOptions = [{name: "Sí", value: true}, {name: "No", value: false}];
const compactAcceptOptions = ["Sí", "Sí provisional hasta entrega furgoneta", "No"];
const reasonOptions = ["Mecánica", "Chapa"];
const [shouldHideFields, setShouldHideFields] = useState(false);
const [shouldHideFieldsPool, setShouldHideFieldsPool] = useState(false);
const [shouldHideFieldsShortRent, setShouldHideFieldsShortRent] = useState(false);
const [shouldHideFieldsBag, setShouldHideFieldsBag] = useState(true);
const [disableCategoryField, setDisableCategoryField] = useState(false);






useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))   
},[])

useEffect(()=>{
    if(factoryActive){
        dispatch(getFactoryProvincesWithOffices());
        dispatch(getFactoryProvinces())
        dispatch(getFactoryRentTypes());
        dispatch(getFactoryChannels());
        dispatch(getFactoryCategories());
        dispatch(getFactoryRates());
        dispatch(getFactoryTypes());
        dispatch(getFactoryBranches({query:`?plate=${plate}&CustomerCode=${customerCode}`})) 
    }

    },[])

useEffect(()=>{
    if(branches.length > 0){
        onChange("branch", branches[0].description)
    }
},[branches])

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}
function changeDate(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}
function setDriverPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("driverPhoneNumber", filteredNumber)
}
function setWorkshopPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("workshopPhone", filteredNumber)
}

useEffect(()=>{
    if(factoryActive){
        if(dataForm?.province){
            const provinceId = allProvinces.find(factoryProvince=> factoryProvince.description === dataForm.province).id; 
            if(type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE){
                dispatch(getFactoryOfficesByProvinceId({query: `?provinceId=${provinceId}`}));
            } else if (type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN){
                dispatch(getFactoryCities({query: `?provinceId=${provinceId}`}));
            }
           
            onChange("city", null)
            onChange("office", null)
        }   
    }
},[dataForm?.province, type])

useEffect(()=>{
    if(factoryActive){
        if(dataForm?.city && type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE){
            const cityId = cities.find(factoryCity=> factoryCity.description === dataForm.city).id; 
            dispatch(getFactoryOfficesByCityId({query:`?cityId=${cityId}`}))
            onChange("office", null)
        }
    }

},[dataForm?.city])

useEffect(()=>{
    if(dataForm?.province){
        onChange("province", null)
        onChange("city", null)
        onChange("office", null)
    }
},[type])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    }
},[type, types])

function getProvinceOptionsByType(type){
    switch(type){
        case SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE:
            return provincesWithOffices
        case SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN:
            return allProvinces
    }
}

function getCityOptionsByType(type){
    switch(type){
        case SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE:
            return cities;
        case SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN:
            return allCities; 
    }
}

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

function changeReasignation(value){
    onChange("reasignation",value)
}

function groupDateUntil(date){
    if(!date)
        return null;
    const parsedDate = dayjs(date, "DD/MM/YYYY H:mm:ss")
    return parsedDate.isValid() ? parsedDate.format("DD/MM/YYYY") : null
}


useEffect(()=>{
    let schedules = {};
    if(dataForm.office){
        const office = officesByCity.find(x => x.officeInfo.officeName === dataForm.office);
        if(office) schedules = office.officeInfo
    }
    setOfficeSchedules({...schedules});

},[dataForm?.office])

useEffect(()=>{
    if(dataForm?.rentType){
        setDisableCategoryField(false);
        let rentType = dataForm?.rentType.toLowerCase();

        if(!rentType.includes("ilimitado")){
            dispatch(getFactoryCategories());
        }
        
        if(rentType.includes("pool") || rentType.includes("bolsa") || rentType.replace('í','i').includes("dias")){
            setShouldHideFieldsShortRent(false)
            setShouldHideFields(false);
            setShouldHideFieldsBag(false);

            setShouldHideFieldsPool(true);
        }
        else if(rentType.includes("ilimitado") || rentType.includes("bankia") || rentType.includes("cliente") || rentType.includes("diferencia")){
            setShouldHideFieldsPool(false);
            setShouldHideFieldsShortRent(false)
            

            setShouldHideFields(true);
            setShouldHideFieldsBag(true);

            if(rentType.includes("ilimitado")){
                dispatch(getFactoryCategoriesSVUnlimited({query:`?plate=${plate}`})).then((data) => {
                    if(data.payload && data.payload.length > 0){
                        onChange("category",data.payload[0].description);
                    }else{
                      dispatch(openModal({ type: "warning", message: "La matrícula del caso no posee contratado vehículo de sustitución ilimitado"}))
                      onChange("category",null);
                    }
                    setDisableCategoryField(true);
                  });

            }
        }
        else if(rentType.includes("corto")){
            setShouldHideFieldsPool(false);
            setShouldHideFields(false);

            setShouldHideFieldsShortRent(true);
            setShouldHideFieldsBag(true);
        }else{
            setShouldHideFieldsPool(false);
            setShouldHideFields(false);
            setShouldHideFieldsShortRent(false); 
            setShouldHideFieldsBag(true);
        }
    }

},[dataForm?.rentType])


useEffect(()=>{
    if(dataForm?.rentType)
    {
        let rentType = dataForm?.rentType.toLowerCase();
        if(rentType.includes("bolsa"))
        {
            dispatch(getFactoryModalityBag({query:`?CustomerCode=${customerCode}`}))
                .then(
                    action => onChange("groups", action.payload)
                )
        }
        else if(rentType.includes("pool"))
        {
            dispatch(getFactoryModalityPool({query:`?Plate=${plate}`}))
                .then(
                    action => onChange("groups", action.payload)
                )
        }
        else if(rentType.replace('í','i').includes("dias"))
        {
            dispatch(getFactoryModalityTypeDaysYear({query:`?Plate=${plate}`}))
                .then(
                    action => onChange("groups", action.payload)
                )
        } else {
            onChange("groups", null)
        }
    }

},[dataForm?.rentType])

    return(
        <div className={classes.containers} id="documentation-request-form">
              <InputWrapper classes={classes} label={"Tipología"}>
                    <SelectBox disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} height={25}></SelectBox>
                </InputWrapper>      
                    <div>
                    {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN &&
                        <InputWrapper classes={classes} label={"Matrícula a devolver"}>
                            <TextBox maxLength={50} key={"returnPlate"} name="returnPlate" value={dataForm?.returnPlate} onValueChanged={(e) => onChange("returnPlate", e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    }
                    {  type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE &&
                        <div>
                            <div>
                                <InputWrapper classes={classes} label={"Reasignación"}>
                                    <CheckBox key={"reasignation"} name="reasignation" value={dataForm?.reasignation?dataForm?.reasignation:false} onValueChanged={(e) => changeReasignation(e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                                </InputWrapper>    
                            </div>
                            <div className={classes.input_grid}>
                                {dataForm?.reasignation&&
                                    <InputWrapper classes={classes} label={"Matrícula entrante"}>
                                        <TextBox key={"plateIn"} name="plateIn" value={dataForm?.plateIn} onValueChanged={(e) => onChange("plateIn",e.value)} className={classes.controlers} height={25}></TextBox>
                                    </InputWrapper>
                                }
                            </div>
                                {dataForm?.reasignation&&
                                <div className={classes.input_grid} style={{marginBottom: "10px"}}>        
                                    <InputWrapper classes={classes} label={"Matrícula sustitución"}>
                                        <TextBox key={"plateSubstitution"} name="plateSubstitution" value={dataForm?.plateSubstitution} onValueChanged={(e) => onChange("plateSubstitution",e.value)} className={classes.controlers} height={25}></TextBox>
                                    </InputWrapper>                    
                                    <InputWrapper classes={classes} label={"Matrícula salida"}>
                                        <TextBox key={"plateOut"} name="plateOut" value={dataForm?.plateOut} onValueChanged={(e) => onChange("plateOut",e.value)} className={classes.controlers} height={25}></TextBox>
                                    </InputWrapper>                      
                                </div>
                                }       
                            
                                <InputWrapper classes={classes} label={" "}>
                                    <div className={factoryActive? classes.branch_wrapper : classes.branch_wrapper_disabled}>
                                        {dataForm?.branch}   
                                    </div>
                                </InputWrapper>
                        </div>

                    }
                    {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN &&
                            <InputWrapper classes={classes} label={"Código postal"}>
                            <TextBox maxLength={5} key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onValueChanged={(e) => onChange("postalCode", e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    }
                    {type !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_OTHER &&
                        <>
                        <div className={classes.input_grid}>
                            <InputWrapper classes={classes} label={"Provincia"}>
                                {factoryActive || ( !factoryActive && type !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN)?
                                    <SelectBox disabled={!type || !factoryActive} searchEnabled key={"province"} name="province" valueExpr={"description"} displayExpr="description" value={dataForm?.province} className={classes.controlers} height={25} onValueChanged={(e) => { onChange("province", e.value)}} placeholder="" dataSource={getProvinceOptionsByType(type)} ></SelectBox>
                                    : <TextBox key={"province"} name="province" value={dataForm?.province} onValueChanged={(e) => onChange("province",e.value)} className={classes.controlers} height={25}></TextBox>
                                }
                            </InputWrapper>
                            <InputWrapper classes={classes} label={"Localidad"}>
                                {factoryActive || ( !factoryActive && type !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN)?
                                    <SelectBox 
                                        searchEnabled 
                                        disabled={!dataForm?.province || !factoryActive} 
                                        valueExpr={"description"} 
                                        displayExpr={"description"}
                                        key={"city"} 
                                        name="city" 
                                        value={dataForm?.city} 
                                        onValueChanged={(e) => onChange("city",e.value)} 
                                        className={classes.controlers} 
                                        dataSource={{store: getCityOptionsByType(type), paginate: true, pageSize: 20}} 
                                        height={25}
                                        placeholder=""
                                        itemRender={(item)=><div className={classes.custom_item_factory}>{item.description}</div>}
                                        >
                                        </SelectBox>
                                        : <TextBox key={"city"} name="city" value={dataForm?.city} onValueChanged={(e) => onChange("city",e.value)} className={classes.controlers} height={25}></TextBox>
                                }
                            </InputWrapper>
                        </div>

                        </>
                        }
                        {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE &&
                        <>
                            <InputWrapper classes={classes} label={"Oficina"}>
                                <SelectBox 
                                    value={dataForm?.office}
                                    valueExpr={"officeInfo.officeName"} 
                                    displayExpr="officeInfo.officeName" 
                                    onValueChanged={(e) => onChange("office",e.value)} 
                                    placeholder="" 
                                    dataSource={{store: officesByCity, paginate: true, pageSize: 20}} 
                                    height={25}
                                    disabled={!dataForm?.city || !factoryActive}
                                    noDataText="No hay oficinas para la localidad seleccionada"
                                    itemRender={(item)=><div className={classes.custom_item_factory}>{item.officeInfo.officeName}</div>}
                                >
                                </SelectBox>
                            </InputWrapper>
                            <InputWrapper classes={classes} label={"Horario Lunes a Viernes"}>
                                    <TextBox disabled={!factoryActive}  key={"weekdaySchedule"} name="weekdaySchedule" value={officeSchedules.weekdaySchedule} className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>
                            <div className={classes.input_grid}>
                                <InputWrapper classes={classes} label={"Horario Sábado"}>
                                    <TextBox disabled={!factoryActive} key={"saturdaySchedule"} name="saturdaySchedule" value={officeSchedules.saturdaySchedule} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>
                                <InputWrapper classes={classes} label={"Horario Domingo"}>
                                    <TextBox disabled={!factoryActive} key={"sundaySchedule"} name="sundaySchedule" value={officeSchedules.sundaySchedule} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>
                            </div>
                        </>
                        }
                        {type !== SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE&&
                        <>
                            <div className={classes.input_grid}>
                                <InputWrapper classes={classes} label={"Nombre"}>
                                    <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>
                                <InputWrapper classes={classes} label={"Apellidos"}>
                                    <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>
                            </div>
                            <div className={classes.input_grid} style={{marginBottom: "10px"}}>                           
                                <InputWrapper classes={classes} label={"Móvil"}>
                                    <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>    
                                <InputWrapper classes={classes} label={"Correo electrónico"}>
                                    <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>                          
                            </div>
                        </>}
                    </div>
                {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE&&
                    <> 
                        <div className={classes.input_grid} style={{marginBottom: !shouldHideFieldsPool && !shouldHideFields ? 0 : 10}}>  
                            <InputWrapper classes={classes} label={"Modalidad alquiler"}>
                                <SelectBox disabled={!factoryActive} value={dataForm?.rentType} onValueChanged={(e) => onChange("rentType",e.value)} valueExpr={"description"} displayExpr="description" placeholder="" dataSource={rentTypes} height={25}></SelectBox>
                            </InputWrapper>
                        {!shouldHideFieldsPool && !shouldHideFields &&
                            <InputWrapper classes={classes} label={"Canal"}>
                                <SelectBox disabled={!factoryActive} value={dataForm?.channel} valueExpr={"description"} displayExpr="description" onValueChanged={(e) => onChange("channel",e.value)} placeholder="" dataSource={channels} height={25}></SelectBox>
                            </InputWrapper>
                        }
                        </div> 
                            <InputWrapper classes={classes} label={"Categoría"}>
                                    <SelectBox
                                        disabled={!factoryActive} 
                                        readOnly={disableCategoryField}
                                        value={dataForm?.category} 
                                        valueExpr={"description"} 
                                        displayExpr="description"
                                        onValueChanged={(e) => onChange("category",e.value)} 
                                        placeholder="" 
                                        dataSource={categories.filter(category=>category.description)} 
                                        height={25}
                                        itemRender={(item)=><div className={classes.custom_item_factory}>{item.description}</div>}
                                        >
                                        </SelectBox>
                            </InputWrapper>
                        {!shouldHideFieldsPool && !shouldHideFieldsShortRent &&
                        <div className={classes.input_grid}>  
                                                        <InputWrapper classes={classes} label={"Tipo"}>
                                                        <SelectBox disabled={!factoryActive} value={dataForm?.typeInfo} valueExpr={"description"} displayExpr="description" onValueChanged={(e) => onChange("typeInfo",e.value)} placeholder="" dataSource={typesInfo} height={25}></SelectBox>
                                                </InputWrapper>
                            <InputWrapper classes={classes} label={"Motivo"}>
                                <SelectBox value={dataForm?.reason} onValueChanged={(e) => onChange("reason",e.value)} placeholder="" dataSource={reasonOptions} height={25}></SelectBox>
                            </InputWrapper>  
                            </div>
                        }   
                        <div className={classes.input_grid}>         
                            <InputWrapper classes={classes} label={"Fecha y hora"}>
                                <DateBox displayFormat={"dd/MM/yyyy HH:mm"} applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" value={dataForm?.date} onValueChanged={(e) => changeDate("date", e.value)} className={classes.controlers} height={25}></DateBox>
                            </InputWrapper>     
                            <InputWrapper classes={classes} label={"Duración (días)"}>
                                <TextBox key={"duration"} maxLength={9} name="duration" value={dataForm?.duration}onValueChanged={(e) => onChange("duration",e.value)}  className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>                     
                        </div> 

                        
                        {!shouldHideFieldsBag && groups.length > 0 &&
                            <div style={{fontSize: "12px",  marginBottom: 10}}>
                                <div className={"bag-groups-table-grid"} style={{color: "#eeeeee"}}>
                                    <div>Grupo</div> <div>Días disp.</div> <div style={{textAlign: "right"}}>F. hasta</div>
                                </div>
                                {groups.map((group, index)=>
                                        <div className={"bag-groups-table-grid"} key={`${group.secondaryDescription}-${index}`}>
                                            <TextBox readOnly name="group" value={group.secondaryDescription} onValueChanged={(e) => onChange("group",e.value)} className={classes.controlers} height={25}></TextBox>
                                            <TextBox readOnly style={{textAlign: "right"}} name="avaliableDays" value={group.description} onValueChanged={(e) => onChange("avaliableDays",e.value)} className={classes.controlers} height={25}></TextBox>
                                            <TextBox readOnly style={{textAlign: "right"}} name="dateUntil" value={groupDateUntil(group.tertiaryDescription)} onValueChanged={(e) => onChange("dateUntil",e.value)} className={classes.controlers} height={25}></TextBox>
                                        </div>
                                )}
                             </div>
                        }
                        <div className="dx-field" style={{marginBottom: "-5px"}}>
                                <label className={classes.label} >Dados contacto</label> 
                                <hr class="solid"></hr>
                        </div>                       
                        <div className={classes.input_grid}>
                            <InputWrapper classes={classes} label={"Nombre"}>
                                <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>
                            <InputWrapper classes={classes} label={"Apellidos"}>
                                <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>
                        </div>
                        <div className={classes.input_grid} style={{marginBottom: "10px"}}>                           
                            <InputWrapper classes={classes} label={"Móvil"}>
                                <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>    
                            <InputWrapper classes={classes} label={"Correo electrónico"}>
                                <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>                          
                        </div>

                            <div className="dx-field" style={{marginBottom: "-5px"}}>
                                    <label className={classes.label} >Dados conductor</label> 
                                    <hr class="solid"></hr>
                            </div>
                        
                            <div className={classes.input_grid}>
                                <InputWrapper classes={classes} label={"Nombre"}>
                                    <TextBox key={"driverName"} name="driverName" value={dataForm?.driverName} onValueChanged={(e) => onChange("driverName",e.value)} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>
                                <InputWrapper classes={classes} label={"Apellidos"}>
                                    <TextBox key={"driverSurname"} name="driverSurname" value={dataForm?.driverSurname} onValueChanged={(e) => onChange("driverSurname",e.value)} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>
                            </div>
                            <div className={classes.input_grid}>                           
                                <InputWrapper classes={classes} label={"DNI"}>
                                    <TextBox value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)} className={classes.controlers} height={25}/>
                                </InputWrapper>   
                                <InputWrapper classes={classes} label={"Correo electrónico"}>
                                    <TextBox key={"driverEmail"} name="driverEmail" value={dataForm?.driverEmail} onValueChanged={(e) => onChange("driverEmail",e.value)} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>                           
                            </div>
                            <div style={{marginBottom: "10px"}}>  
                                <InputWrapper classes={classes} label={"Conductores adicionales"}>
                                        <TextBox key={"additionalDrivers"} name="additionalDrivers" value={dataForm?.additionalDrivers} onValueChanged={(e) => onChange("additionalDrivers",e.value)} className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>
                            </div>
                        
                        {!shouldHideFieldsPool && !shouldHideFieldsShortRent &&                         
                            <InputWrapper classes={classes} label={"Nombre taller"}>
                                <TextBox key={"workshop"} name="workshop" value={dataForm?.workshop} onValueChanged={(e) => onChange("workshop",e.value)} className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>
                        }
                        <div className={classes.input_grid}>                           
                            <InputWrapper classes={classes} label={"Solicita furgoneta"}>
                            <SelectBox key={"vanRequest"} name="vanRequest" valueExpr={"value"} displayExpr="name" value={dataForm?.vanRequest} className={classes.controlers} height={25} onValueChanged={(e) => { onChange("vanRequest", e.value)}} placeholder="" dataSource={vanRequestOptions}></SelectBox>
                            </InputWrapper>
                        {!shouldHideFieldsPool && !shouldHideFields &&
                            <InputWrapper classes={classes} label={"MTR"}>
                                <SelectBox searchEnabled key={"mtr"} name="mtr" valueExpr={"value"} displayExpr="name" value={dataForm?.mtr} className={classes.controlers} height={25} onValueChanged={(e) => { onChange("mtr", e.value)}} placeholder="" dataSource={mtrSubtypes} ></SelectBox>
                            </InputWrapper>    
                        }
                        </div>
                        {dataForm?.vanRequest &&
                        <>
                            <div>                           
                                <InputWrapper classes={classes} label={"Nº plazas solicitadas"}>
                                    <TextBox key={"placesNumber"} maxLength={9} name="placesNumber" value={dataForm?.placesNumber} onValueChanged={(e) => onChange("placesNumber",e.value)}  className={classes.controlers} height={25}></TextBox>
                                </InputWrapper>
                                </div>
                                <div>
                                <InputWrapper classes={classes} label={"Acepta compacto"}>
                                    <SelectBox value={dataForm?.compactAccept} onValueChanged={(e) => onChange("compactAccept",e.value)} placeholder="" dataSource={compactAcceptOptions} height={25}></SelectBox>
                                </InputWrapper>                                   
                            </div>
                        </>
                        }
                    </>  
                }
                {type === SubstitutionVehicleTemplateTypes.SUBSITUTION_VEHICLE_RETURN &&
                    <div className={classes.input_grid}>                           
                        <InputWrapper classes={classes} label={"Calle"}>
                            <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                        <InputWrapper classes={classes} label={"Número"}>
                            <TextBox maxLength={10} key={"streetNumber"} name="streetNumber" value={dataForm?.streetNumber} onValueChanged={(e) => onChange("streetNumber",e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    </div>
                }
        <InputWrapper classes={classes} label={"Notas"}>
            <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
        </InputWrapper>
        </div>
    )
}

export { SubstitutionVehicleRequestForm }